import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "viewport"]

  connect() {
    this.currentIndex = this.slideTargets.findIndex((slide) => slide.classList.contains("news-article-reviews__slide--active"))
    if (this.currentIndex < 0) {
      this.currentIndex = 0
    }

    this.syncViewportHeight()
    this.showSlide(this.currentIndex)

    this.onResize = () => this.syncViewportHeight()
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
  }

  previous() {
    this.showSlide((this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length)
  }

  next() {
    this.showSlide((this.currentIndex + 1) % this.slideTargets.length)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, slideIndex) => {
      slide.classList.toggle("news-article-reviews__slide--active", slideIndex === index)
    })
    this.currentIndex = index
  }

  syncViewportHeight() {
    if (!this.hasViewportTarget || this.slideTargets.length === 0) return

    let maxHeight = 0

    this.slideTargets.forEach((slide) => {
      const previousPosition = slide.style.position
      const previousVisibility = slide.style.visibility
      const previousDisplay = slide.style.display

      slide.style.position = "absolute"
      slide.style.visibility = "hidden"
      slide.style.display = "block"

      maxHeight = Math.max(maxHeight, slide.offsetHeight)

      slide.style.position = previousPosition
      slide.style.visibility = previousVisibility
      slide.style.display = previousDisplay
    })

    this.viewportTarget.style.height = `${maxHeight}px`
  }
}
